module.exports = __webpack_public_path__ + "img/arh_7.069b7967.jpg";